<template>
  <div class="pm-dialog-vehicle">
    <div class="flex justify-center outer-area">
      <div class="vs-row w-full">
        <div
          class="vs-col pm-dialog-equipment-col"
          v-for="(master, index) in masterList"
          :key="index"
          @mousedown="onClick(master.id)"
        >
          <vs-chip
            :color="itemColor(master.id)"
            :transparent="itemTransparent(master.id)"
            :class="[
              itemTransparent(master.id)
                ? 'pm-chip-with-border'
                : 'pm-chip-without-border',
            ]"
          >
            {{ master.label }}
          </vs-chip>
        </div>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button class="button" color="#2E87B9" @mousedown="closePopup">
        <span class="button-text">キャンセル</span>
      </vs-button>
      <vs-button color="#2E87B9" class="button" @mousedown="onSubmit(false)">
        <span class="button-text">保存 </span>
      </vs-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("gkmgPortMasterDestinationWork");
import moment from "moment-timezone";
import { VEHICLES_MASTER, VEHICLES_STATUS } from "@/config/const.js";

export default {
  props: {
    taskId: { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap: { required: true },
    closePopup: { type: Function, required: true },
  },
  data() {
    return {
      isCount: false,
      selectedIds: [],
      selectedId: null,
    };
  },
  watch: {
    summaryDialogShowPopup() {
      if (this.summaryDialogShowPopup === false) {
        setTimeout(() => {
          this.selectedIds = [];
        }, 300);
      } else {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      summaryDialogShowPopup: (state) => state.summaryDialogShowPopup,
    }),
    masterList() {
      let masterList = [];
      if (this.isCount === true) {
        const listLength = VEHICLES_MASTER.length;
        for (let i = 1; i <= listLength; i++) {
          masterList.push({ id: i, name: i + "T" });
        }
      } else {
        masterList = VEHICLES_MASTER;
      }
      return masterList;
    },
    isUpdateTimeStamp() {
      return this.inputValue ||
        (this.valueMap.changes && this.valueMap.changes[String(this.columnKey)])
        ? true
        : false;
    },
  },
  methods: {
    initData() {
      if (Object.hasOwn(this.valueMap, "itSelf")) {
        this.selectedIds = JSON.parse(JSON.stringify(this.valueMap.itSelf));
      } else {
        this.selectedIds = [];
      }
    },
    itemColor(masterId) {
      let itemColorCode = "#081e29";
      let foundId =
        this.selectedIds.length > 0
          ? this.selectedIds.find((el) => el.id === masterId)
          : null;
      if (foundId) {
        if (foundId.status === VEHICLES_STATUS.ORDERED) {
          itemColorCode = "#09151c";
        }
      }
      return itemColorCode;
    },
    itemTransparent(masterId) {
      let foundId =
        this.selectedIds.length > 0
          ? this.selectedIds.find((el) => el.id === masterId)
          : null;
      if (foundId) {
        if (foundId.status === VEHICLES_STATUS.ORDERED) {
          return false;
        }
      }
      return true;
    },
    onClick(masterId) {
      let foundSelectedId = this.selectedIds
        ? this.selectedIds.find((el) => el.id === masterId)
        : null;
      if (foundSelectedId) {
        // statusが1の時は「オーダーをまだしていない」状態、3の時は「オーダー完了」の状態、2「オーダー中」の状態。
        // 現状の仕様では、1,3のみを使用して、2の状態は想定しない。
        foundSelectedId.status =
          foundSelectedId.status === VEHICLES_STATUS.NOT_ORDERED
            ? VEHICLES_STATUS.ORDERED
            : VEHICLES_STATUS.NOT_ORDERED;
      } else {
        let newSelectedId = JSON.parse(
          JSON.stringify(
            this.masterList.find((master) => master.id === masterId),
          ),
        );
        newSelectedId.status = VEHICLES_STATUS.ORDERED;
        this.selectedIds.push(newSelectedId);
      }
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = [];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp");
      const updateKeyValueMap = {};

      updateKeyValueMap[this.columnKey] = this.selectedIds
        ? this.selectedIds
        : null;

      updateKeyValueMap["updated_at"] = new Date(
        moment().local().format("YYYY-MM-DD HH:mm:ss"),
      );
      this.$emit("updateValue", this.taskId, updateKeyValueMap, mode);
    },
  },
  created() {
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-vehicle {
  .outer-area {
    padding: 1rem;
    margin: 1rem 6rem;
  }
  .pm-dialog-equipment-col {
    margin: 0.2rem;
    padding: 0rem;
    .con-vs-chip {
      border-radius: 6px;
      height: 3rem;
      font-size: 120%;
      min-width: 3rem;
    }
    .pm-chip-with-border {
      border: 2px solid #20678f;
      box-sizing: border-box;
      background-color: $pm-paper-white !important;
    }
    .pm-chip-without-border {
      border: 2px solid;
      box-sizing: border-box;
      background-color: #20678f !important;
    }
  }
  .button {
    width: 230px;
    height: 46px;
    margin: 0 1rem;
    border-radius: 8px;
    cursor: pointer;
  }
  .button-text {
    width: 32px;
    height: 24px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */
    align-items: center;
    text-align: center;

    color: #f2f2f2;
  }
}
</style>
